import React, { useContext, useEffect } from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'
import recruiterModeContext from '../context/recruiterModeContext'
import About from '../pages/About'
import Achievements from '../pages/Achievements'
import Education from '../pages/Education'
import Experience from '../pages/Experience'
import Home from '../pages/Home'
import PageNotFound from '../pages/PageNotFound'
import Projects from '../pages/Projects'
import Publications from '../pages/Publications'
import RecruiterMode from '../pages/RecruiterMode'
import Skills from '../pages/Skills'
import Volunteering from '../pages/Volunteering'

const AppRoutes = () => {
	const { recruiterMode, setRecruiterMode } = useContext(recruiterModeContext)
	const location = useLocation()
	const params = new URLSearchParams(location.search)
	const recruiterModeFromUrl = location.pathname === '/recruiter' || params.get('recruiter') === 'true' || params.get('mode') === 'recruiter'

	useEffect(() => {
		setRecruiterMode(recruiterModeFromUrl)
	}, [recruiterModeFromUrl, setRecruiterMode])

	if (recruiterModeFromUrl || recruiterMode) {
		return (
			<Routes>
				<Route path="/recruiter" element={<RecruiterMode />} />
				<Route path="*" element={<RecruiterMode />} />
			</Routes>
		)
	}

	return (
		<Routes>
			<Route path="/" element={<Home />} />
			<Route path="/skills" element={<Skills />} />
			<Route path="/about" element={<About />} />
			<Route path="/achievements" element={<Achievements />} />
			<Route path="/publications" element={<Publications />} />
			<Route path="/experience" element={<Experience />} />
			<Route path="/education" element={<Education />} />
			<Route path="/projects" element={<Projects />} />
			<Route path="/volunteering" element={<Volunteering />} />
			<Route path="*" element={<PageNotFound />} />
		</Routes>
	)
}

export default AppRoutes
